import { Unstable_Grid2 as Grid, Typography } from '@mui/material';
import VersionSummary from './childcomponents/versionsummary';
import BuildSummary from './childcomponents/buildsummary';
import ReleaseSummary from './childcomponents/releasesummary';
import { useAppDispatch } from '../../stores/hooks';
import { useEffect } from 'react';
import { setcurrentmenu } from '../../stores/menuslice';
import CurrentTOC from './childcomponents/currenttoc';
import TableCard from './childcomponents/tablecard';
import { TableStatsTypes } from '../../data/interfaces/dashboardmodels';

export default function Dashboard() {
    const dispatch = useAppDispatch();
    useEffect(() => {
        // document.title = `Hello ${name}`;
        dispatch(setcurrentmenu('dashboard'));
        
    },[]);
    return (
        <Grid container spacing={2} sx={{m:1}}>
            <Grid xs={3}>
                <TableCard type={TableStatsTypes.MagneticTable}/>
            </Grid>
            <Grid xs={3}>
                <TableCard type={TableStatsTypes.MagneticOutputTable}/>
            </Grid>
            <Grid xs={3}>
                <TableCard type={TableStatsTypes.ITSOTable}/>
            </Grid>
            <Grid xs={3}>
                <TableCard type={TableStatsTypes.ITSOOutputTable}/>
            </Grid>
            <Grid xs={6}>
                <BuildSummary />
            </Grid>
            <Grid xs={6}>
                <ReleaseSummary />
            </Grid>
            <Grid xs={6}>
                {/* s<VersionSummary /> */}
            </Grid>
        </Grid>
    );
}